import React, { useState, useEffect } from "react";
import commonStyles from '../common/CommonStyles.module.css';

const AdminBooks = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingBook, setEditingBook] = useState(null); // Current book for editing
  const [formValues, setFormValues] = useState({
    name1: "",
    author: "",
    year: "",
    annot: "",
  });
  const [searchQuery, setSearchQuery] = useState(""); // Search query
  const [file, setFile] = useState(null); // State for the uploaded file

  useEffect(() => {
    fetchBooks();
  }, [searchQuery]); // Refetch books when searchQuery changes

  const fetchBooks = async () => {
    setLoading(true);
    try {
      const endpoint = searchQuery
          ? `/api/books/search?search=${searchQuery}`
          : `/api/books`;
      const response = await fetch(endpoint);
      const data = await response.json();
      setBooks(data.content || []);
    } catch (error) {
      console.error("Error fetching books:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`/api/books/${id}`, { method: "DELETE" });
      setBooks(books.filter((book) => book.id !== id));
    } catch (error) {
      console.error("Error deleting book:", error);
    }
  };

  const handleOpenModal = (book = null) => {
    setEditingBook(book);
    setFormValues({
      name1: book?.name1 || "",
      author: book?.author || "",
      year: book?.year || "",
      annot: book?.annot || "",
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingBook(null);
    setFile(null); // Reset file state when closing modal
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Set the selected file
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const method = editingBook ? "PUT" : "POST";
      const url = editingBook
          ? `/api/books/${editingBook.id}`
          : "/api/books";
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValues),
      });
      const newBook = await response.json();
      if (editingBook) {
        setBooks(books.map((book) => (book.id === newBook.id ? newBook : book)));
      } else {
        setBooks((prev) => [...prev, newBook]);
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error saving book:", error);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Пожалуйста, выберите файл для загрузки.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await fetch(`/api/files/books/${editingBook.id}`, {
        method: "POST",
        body: formData,
      });
      if (response.ok) {
        alert("Файл успешно загружен");
        handleCloseModal(); // Close modal after upload
      } else {
        alert("Ошибка при загрузке файла");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className={commonStyles.pageContainer}>
      <div className={commonStyles.contentContainer}>
        <div className={commonStyles.content}>
          <h2 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>
            Управление книгами
          </h2>
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <input
              type="text"
              placeholder="Поиск книг..."
              style={{ flex: 1, minWidth: 220, maxWidth: 400, padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
              value={searchQuery}
              onChange={handleSearch}
            />
            <button
              onClick={() => handleOpenModal()}
              style={{ backgroundColor: 'rgb(151, 1, 14)', color: 'white', borderRadius: 4, fontWeight: 500, padding: '0.8rem 1.5rem', fontSize: '1rem' }}
            >
              <span style={{ fontSize: '1.2rem' }}>+</span> Добавить книгу
            </button>
          </div>
          <div style={{ background: 'white', borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '2rem', color: 'rgb(151, 1, 14)' }}>Загрузка...</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 600, borderRadius: 8, overflow: 'hidden' }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Название</th>
                    <th>Автор</th>
                    <th>Год</th>
                    <th>Действия</th>
                  </tr>
                </thead>
                <tbody>
                  {books.map((book) => (
                    <tr key={book.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                      <td>{book.id}</td>
                      <td>{book.name1}</td>
                      <td>{book.author || "Не указано"}</td>
                      <td>{book.year || "Не указано"}</td>
                      <td>
                        <button
                          onClick={() => handleOpenModal(book)}
                          style={{ backgroundColor: '#2196F3', color: 'white', borderRadius: 4, marginRight: 8, padding: '8px 16px', fontSize: '0.9rem' }}
                        >
                          Редактировать
                        </button>
                        <button
                          onClick={() => handleDelete(book.id)}
                          style={{ backgroundColor: '#ff4444', color: 'white', borderRadius: 4, padding: '8px 16px', fontSize: '0.9rem' }}
                        >
                          Удалить
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {showModal && (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ background: 'white', padding: '2rem', borderRadius: 8, width: '90%', maxWidth: 500 }}>
                <h3 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>{editingBook ? 'Редактировать книгу' : 'Добавить книгу'}</h3>
                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Название</label>
                    <input
                      type="text"
                      name="name1"
                      value={formValues.name1}
                      onChange={handleChange}
                      placeholder="Введите название книги"
                      required
                      style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
                    />
                  </div>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Автор</label>
                    <input
                      type="text"
                      name="author"
                      value={formValues.author}
                      onChange={handleChange}
                      placeholder="Введите имя автора"
                      style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
                    />
                  </div>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Год</label>
                    <input
                      type="text"
                      name="year"
                      value={formValues.year}
                      onChange={handleChange}
                      placeholder="Введите год издания"
                      style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
                    />
                  </div>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Аннотация</label>
                    <textarea
                      name="annot"
                      value={formValues.annot}
                      onChange={handleChange}
                      placeholder="Введите аннотацию"
                      style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem', minHeight: 80 }}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '2rem' }}>
                    <button type="submit" style={{ backgroundColor: 'rgb(151, 1, 14)', color: 'white', borderRadius: 4, padding: '0.8rem 1.5rem', fontSize: '1rem' }}>
                      Сохранить
                    </button>
                    <button
                      type="button"
                      onClick={handleCloseModal}
                      style={{ backgroundColor: '#666', color: 'white', borderRadius: 4, padding: '0.8rem 1.5rem', fontSize: '1rem' }}
                    >
                      Отмена
                    </button>
                  </div>
                </form>
                {editingBook && (
                  <div style={{ marginTop: '2rem' }}>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Загрузить файл</label>
                    <input type="file" onChange={handleFileChange} />
                    <button onClick={handleUpload} style={{ backgroundColor: '#2196F3', color: 'white', borderRadius: 4, marginTop: 8, padding: '8px 16px', fontSize: '0.9rem' }}>
                      Загрузить
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminBooks;